import { Dispatch } from "../../utility/common/storeHelper"
import { actions } from "./slice"
import { useLazyGetDialogTopicsQuery } from "../../api/controllers/dialogs"
import store from "../store"
import { scrollDownMessageInput } from "../../utility/dialogs/scrollDownMessageInput"
import { MESSAGES_PER_PAGE } from "../../utility/dialogs/constant"
import { trimEmptyLines } from "../../utility/dialogs/markdownHelpers"
import { setMessageInputDraft } from "../drafts/actions"
import { safeSplitAtPosition } from "../../utility/common/strings/emojiPairs"

export const closeAllWorkplaceSidebars = () => (dispatch: Dispatch) => {
    dispatch(actions.closeKnowledgeBaseSidebar())
    dispatch(actions.closeArticleSidebar())
    dispatch(actions.closeFastRepliesSidebar())
    dispatch(actions.closeTopicsSidebar())
    dispatch(actions.closePreviousDialogSidebar())
    dispatch(actions.closeDialogHistorySidebar())
    dispatch(actions.closeChannelSelectSidebar())
    dispatch(actions.closeCreateClientSidebar())
    dispatch(actions.closeAddChannelToClientSidebar())
    dispatch(actions.closeDialogInfoSidebar())
}

export function backToDialogList() {
    return (dispatch: Dispatch) => {
        dispatch(actions.unsetCurrentDialogId())
        dispatch(actions.setCurrentClientOmniUserId())
    }
}

export function clearDialogsState() {
    return (dispatch: Dispatch) => {
        dispatch(actions.unsetCurrentDialogId())
        dispatch(actions.setCurrentClientOmniUserId())
        dispatch(actions.setSearchCriterion(""))
    }
}

export function createDialog() {
    return (dispatch: Dispatch) => {
        dispatch(actions.unsetCurrentDialogId())
        dispatch(actions.setCurrentClientOmniUserId())
        dispatch(actions.setCurrentChannel())
        dispatch(actions.finishCreatingDialog())
        dispatch(closeAllWorkplaceSidebars())
        dispatch(actions.createDialog())
    }
}

export const closeKnowledgeBaseSidebar = () => {
    return (dispatch: Dispatch) => {
        dispatch(actions.closeArticleSidebar())
        dispatch(actions.closeKnowledgeBaseSidebar())
    }
}

export const addToMessageInputText = (
    text: string,
    isAddToStart = false,
    shouldHandleCursorPos = false,
    noNextLineAroundPasted = false
) => {
    return (dispatch: Dispatch) => {
        const state = store.getState().dialogs
        const currentClientOmniUserId = state.currentClientOmniUserId
        const cursorPosition = state.inputLastCursorPosition - 1 // Редактор начинает отсчёт с 1
        const currentInputText = state.currentOperatorMessage ?? ""
        const filteredText = trimEmptyLines(text)
        const nextLine = noNextLineAroundPasted ? "" : "\n\n "

        let pasteText: string
        let newCursorPosition: number
        const shouldInsertAtCursor =
            shouldHandleCursorPos && cursorPosition >= 0 && cursorPosition <= currentInputText.length

        if (shouldInsertAtCursor) {
            // Безопасно разделяем строку с учётом surrogate pairs (эмодзи)
            const [beforeCursor, afterCursor] = safeSplitAtPosition(currentInputText, cursorPosition)

            pasteText = `${beforeCursor}${nextLine}${filteredText}${nextLine}${afterCursor}`
            newCursorPosition = beforeCursor.length + nextLine.length + filteredText.length + nextLine.length
        } else {
            if (currentInputText) {
                pasteText = isAddToStart
                    ? `${filteredText}\n\n ${currentInputText}`
                    : `${currentInputText}\n\n ${filteredText}`
            } else {
                pasteText = filteredText
            }
            newCursorPosition = pasteText.length
        }

        dispatch(setMessageInputDraft(pasteText, undefined, !currentClientOmniUserId))
        dispatch(
            actions.setCursorPosition({
                position: newCursorPosition + 1, // Редактор начинает отсчёт с 1
                shouldHandleCursorPosition: true
            })
        )

        // Without timeout, it doesn't work in empty input
        setTimeout(() => {
            if (!isAddToStart) {
                scrollDownMessageInput()
            }
        }, 0)
    }
}

export const switchToDialog =
    (
        dialogId: string,
        omniUserId: string,
        projectId: string,
        getTopics: ReturnType<typeof useLazyGetDialogTopicsQuery>[0]
    ) =>
    (dispatch: Dispatch) => {
        dispatch(actions.setCurrentClientOmniUserId(omniUserId))
        dispatch(actions.setCurrentDialogId(dialogId))
        dispatch(
            actions.setIsUserTyping({
                isTyping: false,
                message: ""
            })
        )

        dispatch(
            actions.setMessagesPaginationState({
                OmniUserId: omniUserId,
                StartTime: 0,
                Count: MESSAGES_PER_PAGE,
                FromTodayDialogs: true,
                ProjectId: projectId
            })
        )
        getTopics({
            ProjectId: projectId
        })
    }
